<div [id]="id" class="banner-slider container py-4 d-flex flex-wrap">
    <div class="row">
        <div class="col mpb-1">
            @if(title!=""){
                
            <div class="float-md-start">               
                <h2 class="sliderTitle" [style.color]="titleColor">{{title}}</h2>     
                <ng-content select="[body]"></ng-content>   
            </div>
            
            }
            @if(linkText!="" || url!=""){
            <div class="float-md-start linkText mb-2">
                <a *ngIf="link!=''" routerLink="{{link}}">{{linkText}}</a>
                <a *ngIf="url!=''" href="{{url}}" target="_blank">{{linkText}}</a>
            </div>   
            }       
        </div>
    </div>
    
    <fa-icon class="slideLeftIcon mx-1" [icon]="faCircleChevronLeft" (click)="slideLeft()" [ngClass]="{'hide': !leftScrollBtnActive}" ></fa-icon>
    <div #box class="sliderBox d-flex flex-row flex-nowrap pt-1 px-1 pb-3">
        <ng-content></ng-content>
    </div>
    <fa-icon class="slideRightIcon mx-1" [icon]="faCircleChevronRight" (click)="slideRight()" [ngClass]="{'hide': !rightScrollBtnActive}" ></fa-icon>   
</div>
